// adminHeader.tsx

import React from 'react';

interface AdminHeaderProps {
    title: string;
    subTitle?: React.ReactNode;
}
const AdminHeader: React.FC<AdminHeaderProps> = ({ title, subTitle }) => {
    return (
        <div className="flex flex-col gap-2 font-montserrat">
            <div className="font-bold text-2xl">
                {title}
            </div>
            <div className="text-base  text-gray-500">
                {subTitle}
            </div>
        </div>
    );
};

export default AdminHeader;

